var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-buttons"},[_c('button',{class:[
         _vm.btnClass,
         (this.type === 'primary') ? _vm.btnPrimClass : '',
         (this.type === 'secondary') ? _vm.btnSecndClass : ''
         ],attrs:{"type":"button"},on:{"click":function($event){return _vm.goTo()}}},[_vm._v("\n      "+_vm._s(_vm.label)+"\n   ")])])}
var staticRenderFns = []

export { render, staticRenderFns }